<div class="vertical-progress-map flex-column">
  <ng-content></ng-content>
</div>